function initializeScrollbars(element) {
  const { OverlayScrollbars } = OverlayScrollbarsGlobal;

  const options = {
    scrollbars: {
      theme: element.dataset.scrollbarTheme,
    },
  };

  OverlayScrollbars(element, options);
}

function initializeAllScrollbars() {
  document.querySelectorAll('[data-scrollbar-theme]').forEach(initializeScrollbars);
}

document.addEventListener('DOMContentLoaded', function () {
  initializeAllScrollbars();
});

subscribe(PUB_SUB_EVENTS.wishlistLoaded, () => {
  initializeAllScrollbars();
});

subscribe(PUB_SUB_EVENTS.facetsUpdate, () => {
  initializeAllScrollbars();
});